import { useMemo } from 'react'

import type { ResolvedGatewayTimeFilter } from '@common/modules/gateways/types/gateway-filter.type'
import { resolveGatewayTimeFilterFromPreset } from '@common/modules/gateways/utils/resolveGatewayTimeFilter'

import { useServiceMapFiltersStore } from '../stores/service-map-filters.store'

export function useServiceMapGatewayTimeFilter(): ResolvedGatewayTimeFilter {
  const timeRangeValue = useServiceMapFiltersStore((state) => state.timeRangeValue)
  const customRangeApplied = useServiceMapFiltersStore((state) => state.customRangeApplied)

  return useMemo(
    () => resolveGatewayTimeFilterFromPreset(timeRangeValue, customRangeApplied),
    [timeRangeValue, customRangeApplied]
  )
}
